import React from "react";
import CarButton from "./CarButton"; 

const UtilityCardInfo = ({
  img,
  title,
  text,
  buttonText,
  buttonTo,
  buttonClass,
  target
}) => {
  return (
    <div className=" d-flex flex-column py-4" style={{ height: "100%" }}>
      {/* Immagine e Titolo affiancati orizzontalmente */}
      <div className="d-flex align-items-center mb-3">
        {/* Immagine con angoli arrotondati e sfondo nero */}
        <div
          className="me-3"
          style={{
            backgroundColor: "var(--dark-1)",
            borderRadius: "999px",
            padding:"18px"
          }}
        >
          {img && (
            <img
              src={img}
              alt={title}
              style={{
                width: "38px",
              }}
            />
          )}
        </div>

        {/* Titolo affiancato all'immagine */}
        <h3 className="title-section-punti-vendita">{title}</h3>
      </div>

      {/* Testo e Pulsante */}
      <div className="d-flex flex-column flex-grow-1 gap-2">
        {/* Testo */}
        <p className="text-black text-justify mb-3" style={{ flexGrow: 1 }}>
          {text}
        </p>

        {/* Pulsante */}
        <div className="d-flex justify-content-start">
          <CarButton
            text={buttonText}
            to={buttonTo}
            target={1}
            customClass={`btn btn-sm ${buttonClass}`} // Usa btn-sm per ridurre il pulsante
          />
        </div>
      </div>
    </div>
  );
};

export default UtilityCardInfo;
